import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Search, FileText, Radar, ShieldAlert, ChevronRight, ArrowUpRight } from 'lucide-react';
import { eur } from '../api';
import { Empty } from '../ui';
import { QUICK, bandOf, todayLong, fmtDay } from './useDashboardData';

function Kpi({ icon: Icon, label, value, testid }) {
  return (
    <div className="exd-card exd-kpi">
      <Icon size={20} className="text-[#8E1B1B]" />
      <small>{label}</small>
      <b data-testid={testid}>{value}</b>
    </div>
  );
}

function ReportRow({ r }) {
  return (
    <Link to={`/portal/report/${r.id}`} className="exd-row" data-testid={`dashboard-report-${r.id}`}>
      <span className="exd-badge" style={{ background: bandOf(r.rating) }}>{r.rating || '–'}</span>
      <span className="nm min-w-0"><b>{r.company_name}</b><small>{r.activity || r.company_id}</small></span>
      <span className="sc">{r.score ?? '–'}<em>/100</em></span>
      <span className="dt">{fmtDay(r.created_at)}</span>
      <ChevronRight size={16} className="text-[#C3BBAE]" />
    </Link>
  );
}

export default function DashExecutive({ user, data }) {
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const { reports, spent, monitored, checks, dist } = data;
  const max = Math.max(1, ...dist.map(([, n]) => n));
  const first = user.name ? ` ${user.name.split(' ')[0]}` : '';
  return (
    <div className="portal-rise">
      <div className="exd-top" data-testid="dashboard-hero">
        <div>
          <h1 className="text-3xl sm:text-4xl lg:text-[42px]">Buongiorno{first}, <b>benvenuto in BOND</b></h1>
          <p>{todayLong()} · Business Information Smart Info</p>
        </div>
        <div className="exd-bal">
          <small>Saldo plafond</small><b data-testid="dashboard-balance">{eur(user.wallet_cents)}</b>
          <span>Speso finora <strong data-testid="dashboard-spent">{eur(spent)}</strong></span>
        </div>
      </div>
      <form className="exd-search" onSubmit={(e) => { e.preventDefault(); navigate(`/portal/ricerca?name=${encodeURIComponent(q)}`); }}>
        <Search size={19} className="text-[#8A8F97] shrink-0" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca azienda per ragione sociale, P.IVA o REA…" data-testid="dashboard-quick-search" />
        <button type="submit" data-testid="dashboard-quick-search-btn">Cerca</button>
      </form>
      <div className="grid grid-cols-3 gap-2 sm:gap-4">
        <Kpi icon={FileText} label="Report acquistati" value={reports.length} testid="dashboard-reports-count" />
        <Kpi icon={Radar} label="Aziende monitorate" value={monitored} testid="dashboard-monitored-count" />
        <Kpi icon={ShieldAlert} label="Reputational check" value={checks} testid="dashboard-checks-count" />
      </div>
      <div className="grid lg:grid-cols-[1.65fr_1fr] gap-4 mt-4">
        <div className="exd-card">
          <h3 className="exd-h3">Ultimi report <Link to="/portal/report" data-testid="dashboard-all-reports">Vedi tutti</Link></h3>
          {reports.length === 0
            ? <Empty icon={FileText} title="Nessun report ancora" text="Cerca un'azienda e acquista il primo report: verrà salvato qui e potrai riaprirlo senza costi." />
            : reports.slice(0, 6).map((r) => <ReportRow key={r.id} r={r} />)}
        </div>
        <div className="flex flex-col gap-4">
          <div className="exd-card">
            <h3 className="exd-h3">Azioni rapide</h3>
            {QUICK.map(({ to, icon: Icon, label, id }) => (
              <Link key={id} to={to} className="exd-act" data-testid={`dashboard-quick-${id}`}>
                <Icon size={18} className="text-[#8E1B1B]" /><span className="flex-1">{label}</span><ArrowUpRight size={15} className="text-[#C3BBAE]" />
              </Link>
            ))}
          </div>
          <div className="exd-card" data-testid="dashboard-rating-dist">
            <h3 className="exd-h3">Rating del portafoglio</h3>
            {dist.map(([k, n]) => (
              <div key={k} className="exd-dist"><span>{k}</span><div><i style={{ width: `${(n / max) * 100}%`, background: bandOf(k) }} /></div><em className="not-italic">{n}</em></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
